let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9mmx3")).then(() => parcelRequire('dPwYt'));